import React from 'react'
import AddMedicine from '../Components/AddMedicineComp/AddMedicine'

const AddMedicineView = () => {
  return (
    <div>
        <AddMedicine />
    </div>
  )
}

export default AddMedicineView